export default __webpack_public_path__ + "static/media/whale.979d4b03.jpg";